import React from 'react';
import { Edit, Trash2 } from 'lucide-react';
import { Button } from '../../ui/button';
import { Badge } from '../../ui/badge';
import { TableCell, TableRow } from '../../ui/table';
import type { ArchiveCategory } from '../../../api/archiveCategoryApi';

export type { ArchiveCategory };

interface ArchiveCategoryTableRowProps {
  category: ArchiveCategory;
  typeColors: Record<string, string>;
  onEdit: (category: ArchiveCategory) => void;
  onDelete: (category: ArchiveCategory) => void;
}

export default function ArchiveCategoryTableRow({
  category,
  typeColors,
  onEdit,
  onDelete,
}: ArchiveCategoryTableRowProps) {
  return (
    <TableRow>
      <TableCell className="font-mono text-sm">{category.category_code}</TableCell>
      <TableCell className="font-medium">{category.category_name}</TableCell>
      <TableCell>
        <Badge className={typeColors[category.archive_type] || typeColors.general}>
          {category.archive_type}
        </Badge>
      </TableCell>
      <TableCell>
        <div className="flex flex-wrap gap-1">
          {(category.applicable_modules || []).map(m => (
            <Badge key={m} className="bg-gray-400 text-white text-xs font-medium">
              {m}
            </Badge>
          ))}
        </div>
      </TableCell>
      <TableCell className="text-center">{category.is_mandatory ? '✓' : '-'}</TableCell>
      <TableCell className="text-center">{category.requires_validation ? '✓' : '-'}</TableCell>
      <TableCell>
        <Badge
          className={
            category.is_active ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-700'
          }
        >
          {category.is_active ? 'Aktif' : 'Tidak Aktif'}
        </Badge>
      </TableCell>
      <TableCell>
        <div className="flex gap-2">
          <Button variant="ghost" size="icon" onClick={() => onEdit(category)}>
            <Edit className="w-4 h-4" />
          </Button>
          <Button variant="ghost" size="icon" onClick={() => onDelete(category)}>
            <Trash2 className="w-4 h-4 text-red-500" />
          </Button>
        </div>
      </TableCell>
    </TableRow>
  );
}
